import { render, staticRenderFns } from "./SalesRecapPrintDetails.vue?vue&type=template&id=5f1d628a&"
import script from "./SalesRecapPrintDetails.vue?vue&type=script&lang=js&"
export * from "./SalesRecapPrintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports